import { isLoggedIn, ServiceError, SpinnerCenter, useRemoteConfig } from "@shapr3d/frontend-lib";
import { useSearchParams } from "react-router-dom";

import ErrorPage from "../../components/ErrorPage/ErrorPage";
import { GenericHeader } from "../../components/Headers/GenericHeader/GenericHeader";
import useAccount from "../../hooks/useAccount";
import { useHandleProjectInvitation } from "../../hooks/useHandleInvitation";
import { useProject } from "../../hooks/useProject";
import { SearchParam, ServiceErrorCode } from "../../types";
import { navigateToAuth } from "../../utils/authUtils";
import ModelViewerPage from "../ModelViewerPage/ModelViewerPage";
import NotFoundPage from "../NotFoundPage/NotFoundPage";
import RequestAccessPage from "../RequestAccessPage/RequestAccessPage";
import RequestAccessPendingPage from "../RequestAccessPage/RequestAccessPendingPage";
import ProjectPage from "./ProjectPage";

// eslint-disable-next-line postcss-modules/no-unused-class
import style from "./ProjectPage.module.css";

export const ProjectPageWrapper = () => {
  // Trigger account fetch to load remote config for logged-in users
  useAccount();

  const [searchParams] = useSearchParams();
  const hasInvitationHash = searchParams.get(SearchParam.InvitationHash);

  const isNewProjectPage = useRemoteConfig("web_new_project_page-ff");
  const { isError: isInvitationError } = useHandleProjectInvitation();
  const { isError: isProjectError, error: projectError } = useProject(Boolean(hasInvitationHash));

  if (isNewProjectPage === undefined) {
    return <SpinnerCenter />;
  }

  if (isNewProjectPage && isInvitationError) {
    return (
      <div className={style.container}>
        <GenericHeader />
        <ErrorPage />
      </div>
    );
  }

  if (isNewProjectPage && hasInvitationHash) {
    return <SpinnerCenter />;
  }

  if (isNewProjectPage && !isLoggedIn() && !hasInvitationHash) {
    navigateToAuth();
    return null;
  }

  if (isNewProjectPage && isProjectError) {
    if (
      projectError instanceof ServiceError &&
      projectError.hasCode(ServiceErrorCode.ProjectForbidden)
    ) {
      return (
        <div className={style.container}>
          <GenericHeader />
          <RequestAccessPage />
        </div>
      );
    }

    if (
      projectError instanceof ServiceError &&
      projectError.hasCode(ServiceErrorCode.ProjectPendingAccess)
    ) {
      return (
        <div className={style.container}>
          <GenericHeader />
          <RequestAccessPendingPage />
        </div>
      );
    }

    return (
      <div className={style.container}>
        <GenericHeader />
        <NotFoundPage isProjectPage />
      </div>
    );
  }

  if (!isNewProjectPage) {
    return <ProjectPage />;
  }
  return <ModelViewerPage />;
};
